import {
  MerchantStatsType,
  MerchStatsItemType,
  StatsPeriod,
} from "@src/widgets/merchantStats/classes/MerchantStats"
export type ChartRow = {
  [key: string]: number | string
  day: string
}

export const getChartNameByType = (t: MerchStatsItemType["type"]) => {
  return {
    [MerchantStatsType.OFF_RAMP]: "Off-ramp",
    [MerchantStatsType.ON_RAMP]: "On-ramp",
    [MerchantStatsType.PAYIN]: "Crypto Payins",
    [MerchantStatsType.PAYOUT]: "Crypto Payouts",
    [MerchantStatsType.REFUND]: "Refunds",
    [MerchantStatsType.TOPUP]: "Top-ups",
  }[t]
}

export const buildChartData = ({
  data,
  period,
}: {
  data: MerchStatsItemType[]
  period: StatsPeriod
}): ChartRow[] => {
  switch (period) {
    case "day":
      return buildDay(data)
    case "week":
      return buildWeek(data)
    case "month":
      return buildMonth(data)
    case "year":
      return buildYear(data)
    default:
      return []
  }
}

const buildDay = (data: MerchStatsItemType[]): ChartRow[] =>
  Object.values(
    data.reduce<Record<string, ChartRow>>((acc, { periods, type }) => {
      const day = Object.keys(periods).sort().at(0)!
      const key = getChartNameByType(type)

      Object.entries(periods[day]!).forEach(([hour, value]) => {
        acc[hour] ??= { day: `${hour}:00` }
        acc[hour]![key] = Number(value)
      })

      return acc
    }, {}),
  ).sort((a, b) => Number(a.label) - Number(b.label))

const buildWeek = (data: MerchStatsItemType[]): ChartRow[] => {
  return Object.values(
    data.reduce<Record<string, any>>((result, item) => {
      const { periods, type } = item
      const key = getChartNameByType(type)

      Object.entries(periods.current_week ?? {}).forEach(([day, value]) => {
        if (!result[day]) {
          result[day] = { day }
        }

        result[day][key] = Number(value)
      })

      return result
    }, {}),
  )
}

const buildMonth = (data: any[]): ChartRow[] =>
  Object.values(
    data.reduce<Record<string, ChartRow>>((acc, { periods, type }) => {
      const month = Object.keys(periods).sort().pop()!
      const key = getChartNameByType(type)

      Object.entries(periods[month]).forEach(([day, value]) => {
        acc[day] ??= { day: day }
        acc[day]![key] = Number(value)
      })

      return acc
    }, {}),
  ).sort((a, b) => Number(a.label) - Number(b.label))

const buildYear = (data: any[]): ChartRow[] =>
  Object.values(
    data.reduce<Record<string, ChartRow>>((acc, { periods, type }) => {
      const year = Object.keys(periods).sort().pop()!
      const key = getChartNameByType(type)

      Object.entries(periods[year]).forEach(([mouth, value]) => {
        acc[mouth] ??= { day: mouth }
        acc[mouth]![key] = Number(value)
      })

      return acc
    }, {}),
  ).sort((a, b) => Number(a.label) - Number(b.label))

export const StatsPeriods: StatsPeriod[] = ["day", "week", "month", "year"]
